import { render, staticRenderFns } from "./ShortcutsModal.vue?vue&type=template&id=d2ebe638&scoped=true"
import script from "./ShortcutsModal.vue?vue&type=script&lang=js"
export * from "./ShortcutsModal.vue?vue&type=script&lang=js"
import style0 from "./ShortcutsModal.vue?vue&type=style&index=0&id=d2ebe638&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2ebe638",
  null
  
)

export default component.exports